<template>
  <div v-drag class="configure-tree position-absolute p-10" :style="{ height: height, top: top }">
    <div class="tree-header w-100 business_dialog_title d-flex flex-row-between flex-align-center">
      <span class="fz-14">组态管理</span>
      <i @click="closeComponent" class="cur_pointer iconfont icon-close"></i>
    </div>
    <div class="tree-box">
      <el-tree
        class="m-t-5 h-100 dialog-body"
        highlight-current
        :data="treeList"
        @node-click="checkConfigure"
        :props="defaultTreeProps"
        check-strictly
        ref="treeList"
        node-key="id"
      >
        <span
          slot-scope="{ node }"
          class="p-l-10 el-tree-node__label w-100 text-overflow flex-row-between"
        >
          <el-tooltip :content="node.label" :open-delay="1000" placement="top">
            <span class="ell tl tree-label">{{ node.label }}</span>
          </el-tooltip>
        </span>
      </el-tree>
    </div>
  </div>
</template>
<script>
import ConfigureManage from '@/services/configureManage'
import DynamicManageService from '@/services/dynamicManageService'
import {
  setFlowDirectionFun,
  closeOrShowFlowDirectionFun,
} from '@/views/dynamicManage/js/renderUVActions'

export default {
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    documentId: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    top: {
      type: String,
      default: '',
    },
    allConvertNodeList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    documentId(val) {
      this.getPipeFlowList()
      this.getConfigureList()
    },
  },
  data() {
    return {
      defaultTreeProps: {
        // 目录树配置选项
        children: 'children',
        label: 'name',
      },
      treeList: [],
      configureDetailList: [], // 组态对象列表
      configureId: null, // 组态id
      clickTreeTimerout: null,
      pipeFlowDataList: [],
      currentFilterPipeNodes: [],
      convertNodeList: [],
      actionList: [],
      currentMixer: null,
    }
  },
  created() {
    this.getPipeFlowList()
    this.getConfigureList()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    // 获取管道流向数据
    async getPipeFlowList() {
      const res = await DynamicManageService.getPipeFlowList({
        documentId: this.documentId,
        pageNo: 1,
        pageSize: 9999,
      })
      if (res && res.code === 0 && res.data) {
        this.pipeFlowDataList = res.data
      }
    },
    async closeComponent() {
      this.$emit('closeComponent', 'ConfigureManage')
    },
    // 获取组态列表
    async getConfigureList() {
      // 获取组态列表
      const dataParams = {
        site_id: this.currentProject.id,
        pageno: 1,
        pagesize: 9999,
        orderby: 'name',
        isasc: true,
        relation_model_document_id: this.documentId || '',
      }
      const res = await ConfigureManage.getConfigureList(dataParams)
      if (res && res.code === 0 && res.data) {
        this.treeList = res.data
      }
    },
    // 选中组态
    async checkConfigure(data) {
      if (this.configureId === data.id) {
        return
      }
      if (this.clickTreeTimerout) {
        clearTimeout(this.clickTreeTimerout)
      }
      // this.initModelVisible()
      this.clickTreeTimerout = setTimeout(async () => {
        this.configureId = data.id
        this.configureDetailList = []
        const dataParams = {
          pageno: 1,
          pagesize: 999,
          three_dimensional_configure_id: data.id,
        }
        const res = await ConfigureManage.getConfigureDetailList(dataParams)
        if (res && res.code === 0 && res.data) {
          this.configureDetailList = _.map(res.data, (item) => {
            return {
              id: item.id,
              modelCode: item.modelCode,
              modelName: item.modelName,
            }
          })
          if (!_.isEmpty(this.configureDetailList)) {
            const modelCodes = _.map(this.configureDetailList, 'modelCode')
            console.log(modelCodes)
            const itemInfo = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
            const itemTrees = _.map(itemInfo, 'item')
            await this.player.Native.ModelTree.setItemVisible(itemTrees, false)
            await this.player.Native.ModelTree.setItemVisible(modelCodes, true)
            this.filterPipeNode()
          }
        }
      }, 800)
    },
    async resetNodeVisible() {
      for (let n; n < this.currentFilterPipeNodes; n++) {
        const currentItem = this.currentFilterPipeNodes[n]
        await closeOrShowFlowDirectionFun(
          this.player,
          currentItem.playerModelPipleName,
          this.allConvertNodeList,
          false
        )
      }
    },
    // 设置管道流动效果
    async filterPipeNode() {
      console.log(this.configureDetailList, this.pipeFlowDataList)
      await this.resetNodeVisible()
      this.currentFilterPipeNodes = _.filter(this.pipeFlowDataList, (item) => {
        return !_.isNil(_.find(this.configureDetailList, ['modelName', item.playerModelPipleName]))
      })
      console.log(this.currentFilterPipeNodes, '---this.currentFilterPipeNodes-----')
      for (let i = 0; i < this.currentFilterPipeNodes.length; i += 1) {
        const item = _.cloneDeep(this.currentFilterPipeNodes[i])
        // eslint-disable-next-line no-await-in-loop
        await this.initPipeNode(item)
      }
    },
    // 设置流动效果
    async setFlowDynamic(data, node, url) {
      const currentNodeList = []
      // 获取节点子级
      const nodeChildren = await this.player.Native.NodeProxy.getNodeChildrenRecursion(node)
      for (let i = 0; i < nodeChildren.length; i += 1) {
        const e = nodeChildren[i]
        if (e.nodePtr) {
          // 模型名称前面带/的都是kks不需要设置材质
          const nodeReplaceList = e.name.split('/')
          if (nodeReplaceList[0] || !e.name) {
            // eslint-disable-next-line no-await-in-loop
            currentNodeList.push({
              ...e,
              direction: data.flowDirection,
              // eslint-disable-next-line no-restricted-properties
              time: _.round(100 / data.speed, 2),
              imagePath: url,
            })
          }
        }
      }
      batchSetMaterial(this.player, currentNodeList, url)
      const mixerObj = _.find(this.currentMixer, ['id', this.configureId])
      const { mixer } = await batchNodesUV(
        mixerObj.mixer,
        this.player,
        currentNodeList,
        data.flowState === 0,
        data.id
      )
      this.currentMixer.push({ id: this.configureId, mixer })
    },
    // 设置模型节点显示隐藏
    async setNodeVisible(data, url) {
      const itemInfo = await this.player.Native.ModelTree.findItemByName(
        data.playerModelPipleName,
        0,
        true,
        3
      )
      await this.player.Native.ModelTree.setItemVisible(itemInfo.item, true)
      const currentNode = _.find(this.convertNodeList, ['item', itemInfo.item])
      let node = null
      if (currentNode) {
        node = currentNode.nodePtr
      } else {
        node = await this.player.Native.ModelTree.convertToNode(itemInfo.item, false)
        this.convertNodeList.push({ item: itemInfo.item, nodePtr: node })
      }
      await this.player.Native.NodeProxy.setNodeVisible(node, true)
      await this.player.Native.ModelTree.setItemVisible(itemInfo.item, false)
      this.setFlowDynamic(data, node, url)
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (this.performance && typeof this.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line no-bitwise
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        // eslint-disable-next-line no-bitwise
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    // 清除uv动画
    async clearUVAction() {
      const currentMixer = _.find(this.currentMixer, ['id', this.configureId])
      if (currentMixer) {
        await this.player.Native.AnimationAction.stopActions(currentMixer.mixer)
      }
    },
    // 初始化管道模型
    async initPipeNode(data) {
      let imagePath = null
      if (data.flowDirection && data.fluidTypeImagePathDesc) {
        imagePath = data.fluidTypeImagePathDesc
      } else {
        imagePath = data.fluidTypeImagePathAsc
      }
      const matImageName = _.last(imagePath.split('/'))
      const matUrl = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/dynamic/pipeFlow/${matImageName}`
      const isExists = await this.player.Native.File.exists(matUrl)
      if (!isExists) {
        await this.player.Native.File.EventDownloadProcessChanged.connect(this.matDownloadProcess)
        await this.player.Native.File.EventDownloadFinish.connect(this.matDownloadFinish(data))
        await this.player.Native.File.downloadFile(
          matUrl,
          'GET',
          `${currentEnv.VUE_APP_PLANT_SERVER}${imagePath}`,
          {},
          (res) => {
            // 代表创建下载任务成功
            if (res) {
              this.loadType = '下载流体类型文件...'
              this.showProgress = true
            } else {
              this.$message.warning('下载文件失败')
            }
          }
        )
      } else {
        await setFlowDirectionFun(
          this.player,
          matUrl,
          data,
          this.allConvertNodeList,
          this.currentMixer
        )
      }
    },
    // 流体类型图片下载进度
    matDownloadProcess(file, bytes, bytesTotal) {
      if (bytesTotal > 0) {
        this.loadPercentage = (bytes / bytesTotal) * 100
      }
    },
    // 流体类型图片下载完毕
    matDownloadFinish(data) {
      const that = this
      const fun = async (file, err, bytesTotal) => {
        that.loadPercentage = 0
        that.showProgress = false
        await that.player.Native.File.EventDownloadProcessChanged.disconnect(
          that.matDownloadProcess
        )
        await that.player.Native.File.EventDownloadFinish.disconnect(fun)
        await setFlowDirectionFun(
          this.player,
          file,
          data,
          this.allConvertNodeList,
          this.currentMixer
        )
      }
      return fun
    },
    // 初始化模型显示
    async initModelVisible() {
      const itemInfo = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
      const itemTrees = _.map(itemInfo, 'item')
      this.player.Native.ModelTree.setItemVisible(itemTrees, true)
    },
  },
  async beforeDestroy() {
    await this.initModelVisible()
    for (let i = 0; i < this.pipeFlowDataList.length; i++) {
      await closeOrShowFlowDirectionFun(
        this.player,
        this.pipeFlowDataList[i].playerModelPipleName,
        this.allConvertNodeList,
        true
      )
      await closeOrShowFlowDirectionFun(
        this.player,
        this.pipeFlowDataList[i].playerModelPipleName,
        this.allConvertNodeList,
        false
      )
    }
  },
}
</script>
<style lang="scss" scoped>

.configure-tree {
  width: 368px;
  background-color: rgba(46, 107, 176, 0.5);
  border-radius: 2px;
  z-index: 99;
  right: 35px;
  padding: 10px;
  .tree-header {
    font-size: 16px;
    color: #fff;
  }
  .tree-box {
    height: calc(100% - 25px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}
@import '../../css/index.scss';

</style>
